// extracted by mini-css-extract-plugin
export default {"loginForm":"style_loginForm__GATDl","errorMsg":"style_errorMsg__qSWJq","otpForm":"style_otpForm__5MUkN","forgotpasswordField":"style_forgotpasswordField__NAD36"};